'use client';

import { LinkStyled } from '@components/common';
import { VideoCameraIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'next-i18next';
import type { ComponentProps } from 'react';

/**
 * @description Link to start an AI interview from the AI chat box.
 * It can receive any props that a LinkStyled component can accept.
 */
export const StartAiInterviewChatButton = (props: ComponentProps<typeof LinkStyled>) => {
  const { t } = useTranslation('common');

  return (
    <LinkStyled
      color="ink"
      styling="none"
      className="flex gap-2.5 rounded-full p-2.5 text-sm hover:bg-surface-100"
      href="/ai-interview"
      {...props}
    >
      <VideoCameraIcon className="size-5" />
      {t('ai.interview.start')}
    </LinkStyled>
  );
};
